/**
 * The first visit lands with the left rail collapsed: the canvas and the
 * chat alone. Closing it writes the person's rail preference, so the first
 * run leaves its own marker and the home puts the rail back on the next
 * visit, the same mechanism the tour uses under its own key.
 */

const MARKER = "co-first-run-closed-rail";

function read(): boolean {
  try {
    return window.localStorage.getItem(MARKER) === "1";
  } catch {
    return false;
  }
}

function write(on: boolean) {
  try {
    if (on) window.localStorage.setItem(MARKER, "1");
    else window.localStorage.removeItem(MARKER);
  } catch {
    // No storage: the rail stays where the first run left it.
  }
}

export function closeRail(
  railOpen: boolean,
  setRailOpen: (open: boolean) => void,
): void {
  if (!railOpen) return;
  write(true);
  setRailOpen(false);
}

export function restoreRail(setRailOpen: (open: boolean) => void): void {
  if (!read()) return;
  write(false);
  setRailOpen(true);
}
